var map = {
	"./captures/1.jpg": 190,
	"./captures/2.jpg": 191,
	"./captures/3.jpg": 192,
	"./themes/environment/cloud.jpg": 193,
	"./themes/environment/fire.jpg": 194,
	"./themes/environment/night.jpg": 195,
	"./themes/message/choose.jpg": 196,
	"./themes/message/collect.jpg": 197,
	"./themes/message/wish.jpg": 198
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 189;